import { render, staticRenderFns } from "./ProductionEstimate.vue?vue&type=template&id=54c15049&scoped=true&"
import script from "./ProductionEstimate.vue?vue&type=script&lang=js&"
export * from "./ProductionEstimate.vue?vue&type=script&lang=js&"
import style0 from "./ProductionEstimate.vue?vue&type=style&index=0&id=54c15049&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c15049",
  null
  
)

export default component.exports